export const pageSize = [10, 20, 50, 100]
export const pageSizeOptions = [
  {value: 10, label: '10'},
  {value: 20, label: '20'},
  {value: 50, label: '50'},
  {value: 100, label: '100'},
]
export const defaultPageSize = 10
export const defaultPage = 1
export const MAX_LENGTH = 100
export const S3_WALLET_CARD_PREVIEW_NAME = 'WALLET_CARD_PREVIEW'
export const S3_WALLET_CARD_NAME = 'WALLET_CARD'
export const S3_WALLET_CARD_PREVIEW_BUCKET_NAME = 'dev-cellcast-wallet-card-preview'

export const TAB_LIST = [
  {key: 'imagePreviewUrl', label: 'Preview'},
  {key: 'cardType', label: 'Card Type'},
  {key: 'cardName', label: 'Card Name'},
  {key: 'createdAt', label: 'Created At'},
  {key: 'updatedAt', label: 'Updated At'},
  {key: 'totalScan', label: 'Total Scan'},
  {key: 'status', label: 'Status'},
  {key: 'action', label: 'Action'},
]

export const CARD_TYPE = [
  {key: 'businessCard', label: 'Business Card'},
  {key: 'coupon', label: 'Coupon'},
  {key: 'loyaltyCard', label: 'Loyalty Card'},
]

export const STEP_KEYS = {
  GETTING_STARTED: 'gettingStarted',
  CARD_DETAILS: 'cardDetails',
  SHARE_CONTACT_DETAILS: 'shareContactDetails',
  FORM_CONNECT: 'formConnect',
}

export const DEFAULT_STEP = 'gettingStarted'
// Steps for wallet card
export const steps = [
  {key: 'gettingStarted', label: 'Getting Started'},
  {key: 'cardDetails', label: 'Card Details'},
  {key: 'shareContactDetails', label: 'Share Contact Details'},
  {key: 'formConnect', label: 'Capture Customer Details'},
]

export enum CardViewType {
  GOOGLE = 'google',
  APPLE = 'apple',
  CONTACT = 'contact',
  FORM_SETTING = 'formSetting',
}

export const SHARE_METHOD = [{key: 'shareToWallet'}, {key: 'shareToContact'}]

export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}
export const VALUE_INACTIVE = 'In-active'
export const VALUE_CARD = 'card'
export const VALUE_CARD_UPPER = 'Card'
export const DEFAULT_PAGE = 1
export const DEFAULT_PAGE_SIZE = 10
export const DEFAULT_PAGE_COUNT = 1
export const TOTAL_SCAN = 'totalScan'
export const MAX_PROMO_ACTION = 3
export const REQUIRED_VALUE = 'Required'
export const OPTIONAL_VALUE = 'Optional'
export const MAX_FIELDS_ALLOWED = 8
export const MIN_FIELDS_ALLOWED = 1
export const MAX_LENGTH_WEBSITE = 100
export const MAX_LENGTH_ADDRESS = 100
export const MAX_LENGTH_NOTES = 500
export const MAX_LENGTH_EMAIL = 200
export const MAX_LENGTH_FULL_NAME = 50
export const MIN_LENGTH_FULL_NAME = 2
export const MAX_LENGTH_COMPANY_NAME = 100
export const MAX_LENGTH_JOB_TITLE = 100
export const DEFAULT_LENGTH = 100
// Form Settings Enum for backend compatibility
export enum WALLET_CARD_FORM_SETTINGS {
  FULL_NAME = 'fullName',
  PHONE = 'phone',
  EMAIL = 'email',
  COMPANY_NAME = 'companyName',
  JOB_TITLE = 'jobTitle',
  ADDRESS = 'address',
  WEBSITE = 'website',
  NOTES = 'notes',
  INTERESTED_VEHICLE_TYPE = 'interestedVehicleType',
}

// Mapping from frontend field placeholder to backend key
export const FIELD_PLACEHOLDER_TO_KEY_MAP: Record<string, WALLET_CARD_FORM_SETTINGS> = {
  'Full Name': WALLET_CARD_FORM_SETTINGS.FULL_NAME,
  Phone: WALLET_CARD_FORM_SETTINGS.PHONE,
  Email: WALLET_CARD_FORM_SETTINGS.EMAIL,
  'Company Name': WALLET_CARD_FORM_SETTINGS.COMPANY_NAME,
  'Job Title': WALLET_CARD_FORM_SETTINGS.JOB_TITLE,
  Address: WALLET_CARD_FORM_SETTINGS.ADDRESS,
  Website: WALLET_CARD_FORM_SETTINGS.WEBSITE,
  Notes: WALLET_CARD_FORM_SETTINGS.NOTES,
  'Interested Vehicle Type': WALLET_CARD_FORM_SETTINGS.INTERESTED_VEHICLE_TYPE,
}

export const FIELD_OPTIONS = [
  {value: 'Full Name', label: 'Full Name'},
  {value: 'Phone', label: 'Phone'},
  {value: 'Email', label: 'Email'},
  {value: 'Company Name', label: 'Company Name'},
  {value: 'Job Title', label: 'Job Title'},
  {value: 'Address', label: 'Address'},
  {value: 'Website', label: 'Website'},
  {value: 'Notes', label: 'Notes'},
  {value: 'Interested Vehicle Type', label: 'Interested Vehicle Type'},
]

export const DEFAULT_FORM_FIELDS = [
  {
    _id: 'default_fullName_1',
    label: 'Full Name',
    key: WALLET_CARD_FORM_SETTINGS.FULL_NAME,
    color: '',
    isRequired: true,
    order: 1,
    isDisplay: true,
  },
  {
    _id: 'default_phone_2',
    label: 'Phone',
    key: WALLET_CARD_FORM_SETTINGS.PHONE,
    color: '',
    isRequired: false,
    order: 2,
    isDisplay: true,
  },
  {
    _id: 'default_email_3',
    label: 'Email',
    key: WALLET_CARD_FORM_SETTINGS.EMAIL,
    color: '',
    isRequired: false,
    order: 3,
    isDisplay: true,
  },
  {
    _id: 'default_companyName_4',
    label: 'Company Name',
    key: WALLET_CARD_FORM_SETTINGS.COMPANY_NAME,
    color: '',
    isRequired: false,
    order: 4,
    isDisplay: false,
  },
  {
    _id: 'default_jobTitle_5',
    label: 'Job Title',
    key: WALLET_CARD_FORM_SETTINGS.JOB_TITLE,
    color: '',
    isRequired: false,
    order: 5,
    isDisplay: false,
  },
  {
    _id: 'default_address_6',
    label: 'Address',
    key: WALLET_CARD_FORM_SETTINGS.ADDRESS,
    color: '',
    isRequired: false,
    order: 6,
    isDisplay: false,
  },
  {
    _id: 'default_website_7',
    label: 'Website',
    key: WALLET_CARD_FORM_SETTINGS.WEBSITE,
    color: '',
    isRequired: false,
    order: 7,
    isDisplay: false,
  },
  {
    _id: 'default_notes_8',
    label: 'Notes',
    key: WALLET_CARD_FORM_SETTINGS.NOTES,
    color: '',
    isRequired: false,
    order: 8,
    isDisplay: false,
  },
]

export type VehicleTypeOption = Readonly<{
  value: string
  label: string
}>

export const VEHICLE_TYPE_OPTIONS: ReadonlyArray<VehicleTypeOption> = [
  {value: 'sedan', label: 'Sedan'},
  {value: 'suv', label: 'SUV'},
  {value: 'hatchback', label: 'Hatchback'},
  {value: 'ute', label: 'Ute'},
  {value: 'van', label: 'Van'},
  {value: 'other', label: 'Other'},
]

export const DEFAULT_COUNTRY_CODE = '+61'
// Country codes with dial codes and flags - matching constantsRegion.CountryCodeMap
export const COUNTRY_CODES = [
  {name: 'Australia', countryCode: '+61', code: 'AU', flag: '🇦🇺'},
  {name: 'United States', countryCode: '+1', code: 'US', flag: '🇺🇸'},
  {name: 'New Zealand', countryCode: '+64', code: 'NZ', flag: '🇳🇿'},
  {name: 'United Kingdom', countryCode: '+44', code: 'UK', flag: '🇬🇧'},
  {name: 'Indonesia', countryCode: '+62', code: 'ID', flag: '🇮🇩'},
]
